import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { pobMunicipio_item } from "../../../../json/poblMunicipio";


const PoblacionMun = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="transparencia_title">
            <h1>Población por Municipio con Unidades Médicas SSH</h1>
            <hr className="tramitehr" />
          </div>
        </div>
      </div>
      <div className="row">
      <ul>
          {pobMunicipio_item.map((item, index) => (
            <li key={index}>
                 <span className="badge bg-primary">
                  .pdf
                </span>   
              <a href={item.comparecencias_item_url} target="_blank" rel="noopener noreferrer">{item.comparecencias_item_nombre}</a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PoblacionMun;
